import * as Sentry from '@sentry/react';

const dsn = process.env.REACT_APP_SENTRY_DSN;

if (dsn) {
   Sentry.init({
      dsn,
      sendDefaultPii: true,
      environment: process.env.NODE_ENV,
      integrations: (integrations) =>
         [
            ...integrations.filter((i) => i.name !== 'Dedupe'),
            Sentry.browserTracingIntegration(),
            Sentry.replayIntegration({
               maskAllText: false,
               blockAllMedia: false,
            }),
         ],
      tracesSampleRate: 1.0,
      replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 1.0,
   });

   // Restore user from session on load (e.g. after refresh) so Sentry always shows email instead of IP
   try {
      const raw = typeof sessionStorage !== 'undefined' && sessionStorage.getItem('user');
      if (raw) {
         const user = JSON.parse(raw) as { id?: string; email?: string };
         if (user?.email) {
            Sentry.setUser({ id: user.id, email: user.email });
         }
      }
   } catch {
      // ignore
   }
}
